import { render } from "./unreadCount.vue?vue&type=template&id=10d324d3&scoped=true"
import script from "./unreadCount.vue?vue&type=script&lang=js"
export * from "./unreadCount.vue?vue&type=script&lang=js"

import "./unreadCount.vue?vue&type=style&index=0&id=10d324d3&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d324d3"]])

export default __exports__